// Card at sign-up (phase 2): the small shared pieces of the start-your-trial screens.
import { api } from '../../api/client';

const CHOICE_KEY = 'aidey_trial_plan_choice';
export const PLAN_KEYS = ['Basics', 'Pro', 'Team'];

/** The zone the person's browser is in, so the trial end date is said in it. */
export function browserTimeZone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { return ''; }
}

/** The plan the person last confirmed, so "Continue to card details" can go straight back. */
export function readPlanChoice() {
  try {
    const raw = window.localStorage.getItem(CHOICE_KEY);
    const v = raw ? JSON.parse(raw) : null;
    if (v && PLAN_KEYS.includes(v.planName) && ['monthly', 'annual'].includes(v.billingPeriod)) return v;
  } catch { /* storage unavailable: no remembered choice */ }
  return null;
}

export function savePlanChoice(planName, billingPeriod) {
  try { window.localStorage.setItem(CHOICE_KEY, JSON.stringify({ planName, billingPeriod })); } catch { /* not kept */ }
}

/** The confirm step's sentence and its parts, from the server (which reads Stripe). */
export async function fetchCheckoutPreview(planName, billingPeriod) {
  const res = await api('/api/billing/checkout-preview', {
    method: 'POST',
    body: JSON.stringify({ planName, billingPeriod, timeZone: browserTimeZone() }),
  });
  return res.json();
}

/** Open Stripe Checkout for the confirmed plan. Resolves to the URL it sent the browser to. */
export async function startCheckout(planName, billingPeriod, { assign = (url) => window.location.assign(url) } = {}) {
  const locale = (typeof navigator !== 'undefined' && navigator.language ? navigator.language.split('-')[0] : '') || 'auto';
  const res = await api('/api/billing/create-checkout-session', {
    method: 'POST',
    body: JSON.stringify({ planName, billingPeriod, locale, timeZone: browserTimeZone() }),
  });
  const data = await res.json();
  if (!data || !data.url) throw new Error('Checkout could not be opened. Please try again.');
  assign(data.url);
  return data.url;
}
